import * as React from "react";
// import PropTypes from "prop-types";
import styled from "styled-components";

const CardHeader = styled.header`
  color: #3d4853;
  background: transparent;
  padding: 12px 0px;
  font-family: "roboto-slab-regular";
  font-size: 16px;
  font-weight: 300;

  a {
    color: #3d4853;
  }
`;

const CardBodyDiv = styled.div`
  background-color: white;
  padding: 24px 34px;
  border-top: 11px solid #3d4853;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`;

interface Props {
  title?: string;
  children?: React.ReactNode;
  headerWidget?: React.ReactNode;
}

function Card({ title, children, headerWidget }: Props) {
  return (
    <div>
      <CardHeader>
        {title}
        <span className="pull-right">{headerWidget}</span>
      </CardHeader>
      <CardBodyDiv>{children}</CardBodyDiv>
    </div>
  );
}

export default Card;



// WEBPACK FOOTER //
// ./app/javascript/components/core/Card.tsx